// removed by extract-text-webpack-plugin
module.exports = {"border":"mc_me","button":"mc_bp","choice":"mc_mf","radioButton":"mc_mg","checkedStyle":"mc_mh mc_mf"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/RadioButtonSwitch/styles.module.css
// module id = 1320
// module chunks = 27